import { FC, useEffect } from 'react'
import Olark from 'react-olark-plugin'
declare global {
  interface Window {
    olark?: (command: string, ...args: unknown[]) => void
  }
}
interface PropTypes {
  apiKey: string
}

const Chat: FC<PropTypes> = ({ apiKey }) => {
  useEffect(() => {
    if (!apiKey || !window.olark) return

    // Show chat when this component mounts
    window.olark('api.box.show')

    // Hide chat when component unmounts
    return () => {
      if (window.olark) {
        window.olark('api.box.hide')
      }
    }
  }, [apiKey])

  if (!apiKey) return null
  return <Olark siteId={apiKey} />
}

export default Chat
